var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 1.83301L4.5375 4.02467C4.67444 4.11604 4.83538 4.1648 5 4.1648C5.16462 4.1648 5.32556 4.11604 5.4625 4.02467L8.75 1.83301M2.08333 6.41634H7.91667C8.13768 6.41634 8.34964 6.32854 8.50592 6.17226C8.6622 6.01598 8.75 5.80402 8.75 5.58301V1.41634C8.75 1.19533 8.6622 0.983366 8.50592 0.827085C8.34964 0.670805 8.13768 0.583008 7.91667 0.583008H2.08333C1.86232 0.583008 1.65036 0.670805 1.49408 0.827085C1.3378 0.983366 1.25 1.19533 1.25 1.41634V5.58301C1.25 5.80402 1.3378 6.01598 1.49408 6.17226C1.65036 6.32854 1.86232 6.41634 2.08333 6.41634Z",
    stroke: "#14674B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMail);
export default __webpack_public_path__ + "static/media/ic_mail.915d89244f6d7d1de2a78d365f065177.svg";
export { ForwardRef as ReactComponent };